const cyan = {
  25: "#F5FEFF",
  50: "#ECFDFF",
  100: "#CFF9FE",
  200: "#A5F0FC",
  300: "#67E3F9",
  400: "#22CCEE",
  500: "#06AED4",
  600: "#088AB2",
  700: "#0E7090",
  800: "#155B75",
  900: "#164C63",
  950: "#0D2D3A",
};

export default cyan;
